import { render, staticRenderFns } from "./ListLogo.vue?vue&type=template&id=1d7bdf73&scoped=true&"
import script from "./ListLogo.vue?vue&type=script&lang=js&"
export * from "./ListLogo.vue?vue&type=script&lang=js&"
import style0 from "./ListLogo.vue?vue&type=style&index=0&id=1d7bdf73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7bdf73",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
